import { render, staticRenderFns } from "./DocumentsSynthesisQuestion.vue?vue&type=template&id=5ec263a2"
import script from "./DocumentsSynthesisQuestion.vue?vue&type=script&lang=ts"
export * from "./DocumentsSynthesisQuestion.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsSynthesisQuestion.vue?vue&type=style&index=0&id=5ec263a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports